import type { Response } from '@ms-cloudpack/create-express-app';

/**
 * Log response info to the console. Will use console.debug for success/redirect, console.error for error.
 */
export function logResponse(params: {
  status: number;
  requestPath: string;
  message?: string;
  /** Console method (could add others as needed) */
  level?: 'error' | 'debug';
}): void {
  const { status, requestPath, message, level = status >= 400 ? 'error' : 'debug' } = params;
  const logMessage = `Bundle response (${status}): ${requestPath}${message ? ` - ${message}` : ''}`;
  console[level](logMessage);
}

/**
 * Log the error to the console and send a plain-text error response.
 */
export function sendErrorResponse(params: {
  res: Response;
  status: number;
  requestPath: string;
  /** Message to send. `&`, `<`, `>` will be HTML-escaped. */
  message: string;
  consoleMessage?: string;
  consoleDetails?: string;
}): void {
  const { res, status, requestPath, message, consoleMessage = message, consoleDetails } = params;
  logResponse({ status, requestPath, message: consoleMessage });
  consoleDetails && console.info(consoleDetails);
  if (!res.headersSent) {
    res
      .status(status)
      .type('text/plain')
      // This probably isn't needed, but in case the error is displayed as HTML text...
      .send(message.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
  }
}
